<template>
	<div>
		<topbar
			v-if="header"
			@search="search = $event"
			@clean="cleanFilters"
		>
			<template
				slot="title"
			>
				<slot name="title" />
			</template>

			<template
				slot="head-right"
			>
				<slot name="head-right" />
			</template>

			<template
				slot="head-left"
			>
				<slot name="head-left" />
			</template>
		</topbar>

		<div
			v-if="!mobile"
			class="card"
		>
			<div class="card-body p-0">
				<div
					class="table-responsive"
					:class="[$style['table-responsive'], !bordered ? $style['table-clean'] : '']"
				>
					<table
						class="table table-hover table-striped"
						:class="$style.table"
					>
						<thead>
							<tr>
								<th
									v-if="select !== false"
									:class="[$style.th,$style.thCheck]"
									class="text-center"
								>
									<a-checkbox
										:indeterminate="checkedSome"
										:checked="checkedAll"
										@change="checkAll($event.target.checked)"
									/>
								</th>
								<th
									v-for="(col, i) in cols"
									:key="i"
									:class="$style.th"
									:style="{'text-align': (col.align || 'left')}"
								>
									{{ col.title || col.index || '???' }}
									<!-- <order-filter
										v-if="col.order"
										:index="col.index"
										@order="onOrder"
									/>

									<select-filter
										v-if="col.filters"
										:index="col.index"
										@select="onFilter"
									/>

									<search-filter
										v-if="col.search"
										:index="col.index"
										@search="onSearch"
									/> -->
								</th>
							</tr>
						</thead>

						<tbody>
							<tr
								v-for="(colData, colDataIndex) in data.results"
								:key="colDataIndex"
							>
								<td
									v-if="select !== false"
									class="text-center"
									:class="$style.td"
								>
									<a-checkbox
										:checked="checked[colDataIndex]"
										@change="check(colDataIndex, $event.target.checked)"
									/>
								</td>
								<td
									v-for="(col, colIndex) in cols"
									:key="colIndex"
									:class="$style.td"
									:align="col.align || 'left'"
								>
									<slot
										v-if="col.slot!==undefined"
										:name="col.slot"
										v-bind="colData"
									>
										{{ colData[col.index] }}
									</slot>

									<div v-else>
										{{ colData[col.index] }}
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>

		<cards v-else>
			<template
				v-for="(col) in cols"
				:slot="col.slot"
				slot-scope="item"
			>
				<slot
					:name="col.slot"
					v-bind="item"
				/>
			</template>

			<template
				slot="_mobile"
				slot-scope="item"
			>
				<slot
					name="_mobile"
					v-bind="item"
				/>
			</template>
		</cards>

		<pagination />
	</div>
</template>

<script>
// import searchFilter from './filters/search';
// import orderFilter from './filters/order';
// import selectFilter from './filters/select';
import topbar from './widgets/topbar';
import pagination from './widgets/pagination';
import cards from './widgets/cards';

export default {
	name: 'GTable',
	components: {
		// searchFilter,
		// orderFilter,
		// selectFilter,
		topbar,
		pagination,
		cards
	},
	props: {
		// Show header bar
		header: {
			type: Boolean,
			default: true
		},
		// Hide refresh button
		hideRefresh: {
			type: Boolean,
			default: false
		},
		// Hide global search
		hideSearch: {
			type: Boolean,
			default: false
		},
		/// ///////////////////////
		// TABLE
		/// ///////////////////////
		bordered: {
			type: Boolean,
			default: false
		},

		/// ///////////////////////
		// QUERIES
		/// ///////////////////////
		select: {
			type: [Array, Boolean],
			default: () => []
		},
		loading: {
			type: Boolean,
			default: false
		},
		pagination: {
			type: String,
			default: 'default'
		},
		limit: {
			type: Number,
			default: null
		},
		disable: {
			type: Boolean,
			default: false
		},
		/// ///////////////////////
		// DATA
		/// ///////////////////////

		// Columns
		columns: {
			type: Array,
			required: true
		},

		// Manually Data
		index: {
			type: String,
			required: true
		},
		data: {
			type: Object,
			required: true,
			default() {
				return {
					results: [],
					total: 0
				};
			}
		}
	},
	data() {
		return {
			page: 1,
			maxPage: 1,
			search: ''
		};
	},
	computed: {
		mobile() {
			if (this.$settings.isMobileView || this.$settings.isTabletView) return true;
			return false;
		},
		cols() {
			return this.columns.map((col) => col);
		},
		checked() {
			return this.data.results.map((i) => {
				const find = this.selected.findIndex((si) => si[this.index] === i[this.index]);
				if (find > -1) return true;
				return false;
			});
		},
		checkedAll() {
			return (this.selected.length === this.data.results.length && this.selected.length > 0);
		},
		checkedSome() {
			return !!this.selected.length && this.selected.length < this.data.results.length;
		},
		/// ///////////////////////
		// QUERIES
		/// ///////////////////////
		filtered() {
			if (this.search) return true;
			return false;
		},
		selected: {
			get() {
				return this.select;
			},
			set(val) {
				this.$emit('select', val);
			}
		}
	},
	watch: {
		search() {
			this.reset();
		},
		limit() {
			this.reset();
		}
	},
	created() {
		this.searchValue = this.search;
	},
	mounted() {
		this.list(true);
		this.maxPage = Math.ceil(parseInt(this.data.total, 10) / parseInt(this.limit, 10));
	},
	methods: {
		/// //////////////////////////
		// LIST & PAGINATION
		/// //////////////////////////
		reset() {
			this.page = 1;
			this.checkAll(false);
			this.list(true);
			this.maxPage = Math.ceil(parseInt(this.data.total, 10) / parseInt(this.limit, 10));
		},
		list(reset = null) {
			if (this.pagination === 'default' && reset === null) reset = true;

			this.$emit('list', {
				limit: this.limit,
				page: this.page,
				filters: null,
				order: null,
				search: this.search,
				reset
			});
		},
		next() {
			this.page += 1;
			this.list();
		},
		back() {
			this.page -= 1;
			this.list();
		},
		/// //////////////////////////
		// CHECK
		/// //////////////////////////
		uncheck(item) {
			const index = this.selected.findIndex((si) => item[this.index] === si[this.index]);
			if (index > -1) {
				this.selected.splice(index, 1);
			}
		},
		check(index, val) {
			const item = this.data.results[index];
			const find = this.selected.findIndex((si) => item[this.index] === si[this.index]);

			if (val && find === -1) {
				this.selected.push(item);
			} else {
				this.uncheck(item);
			}
		},
		checkAll(val) {
			if (val) {
				this.selected.splice(0, this.selected.length);
				this.data.results.forEach((element) => {
					this.selected.push(element);
				});
			} else {
				this.selected.splice(0, this.selected.length);
			}
		},
		/// //////////////////////////
		// FILTERS
		/// //////////////////////////
		cleanFilters() {
			this.search = '';
		}
	}
};
</script>

<style lang="scss" module>
	.table-responsive{
		border: 0;
		border-radius:6px;
		background: white;
		margin: 0;
	}

	.table{
		.th{
			text-transform: uppercase;
			font-family: Rubik;
			font-weight: 500;
			border-top: 0;
		}

		.thCheck{
			width: 50px;
		}

		.td{
			vertical-align: middle;
		}
	}

	.table-clean.table-responsive{
		border: 0;

		td,th{
			border: 0;
		}
	}

</style>
